<template>
  <div>
    <div>
      <img src="../../assets/image/banner-zc_02.png" class="banner" alt="">
    </div>
    <div class="page-container">
      <div class="auction-box">
        <Panel @change="tabChange" :plain="false" :menu="tabs" :current="iscur" :title="'专场拍卖'" :classes="'zc'">
          <Auction :flex="true" :list="list"></Auction>
        </Panel>
        <el-link class="btn-more" :underline="false" disabled v-if="isend">没有更多了</el-link>
        <el-link class="btn-more" :underline="false" @click="getSpecialList" v-if="!isend">加载更多</el-link>
      </div>
    </div>
  </div>
</template>
<script>
import Panel from '../../components/panel.vue'
import Auction from '../../components/auctionlist.vue'
import {
  AuctionAPI
} from "../../model/auction.js";
let auctionAPI = new AuctionAPI();
export default {
  name: 'auction',
  data() {
    return {
      pageIndex: 1,
      pageSize: 10,
      iscur: 0,
      time: [],
      timer: 0,
      nowtime: '',
      tabs: [
        { name: '拍卖中', type: 1 },
        { name: '预拍中', type: 2 },
        { name: '已结束', type: 3 }
      ],
      list: []
    }
  },
  components: {
    Panel,
    Auction
  },
  methods: {
    //获取当前选中的选项
    tabChange: function (index) {
      this.iscur = index
      this.resetOptionStatus()
    },
    getSpecialList() {
      let _this = this;
      return new Promise(function (resolve, reject) {
        auctionAPI.getSpecialList({
          SpecialType: _this.tabs[_this.iscur].type,
          PageIndex: _this.pageIndex,
          PageSize: _this.pageSize,
        }).then((res) => {
          let list = res.data;
          if (list.length < _this.pageSize || list.length == 0) {
            _this.isend = true
          }
          _this.list = list.length > 0 ? _this.list.concat(list) : _this.list;
          _this.pageIndex++
          resolve()
        }, () => {
          reject()
        })
      })
    },
    resetOptionStatus() {
      this.list = [];
      this.pageIndex = 1;
      this.isend = false;
      this.getSpecialList();
    },
  },
  created() {
    this.resetOptionStatus()
  }
}
</script>
<style lang="scss" scoped>
.auction-box {
  margin-top: 80px;
}
</style>